import { faro } from "@/faro";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "@/generated/route/routeTree.gen.ts";
import { useAuthProvider } from "@/app/_providers/auth-provider.tsx";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: {
    auth: undefined!, // This will be set after we wrap the app in an AuthProvider
  },
});

if (import.meta.env.DEV) {
  // Disable Faro on local
  faro?.pause();
}
router.subscribe("onResolved", () => {
  const state = router.state;
  faro?.api?.pushEvent("routeChange", { route: state.location.pathname });
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export default function TanstackRouterProvider() {
  const auth = useAuthProvider();
  return <RouterProvider router={router} context={{ auth }} />;
}
